import React, { useMemo, useEffect, useState } from 'react';
import { grey } from '@mui/material/colors';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import 'features/dashboard/static/downtime/grid/grid.style.css';
import { isDarkMode } from 'app/utils/ColorContext';
import { useCommonInits } from 'hooks/useCommonInits';
import { useSelector } from 'react-redux';
import {
    Typography,
    Box,
    Paper,
    Grid,
    FormControl,
    Button,
    Select,
    MenuItem,
} from '@mui/material';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import {
    getLogsByID,
    getAllAssets,
    getRetryRequests,
    getCancelRequests,
} from 'redux/datasource/dataSourceActions';
import {
    getAssets,
    getExecuteLogsByID,
} from 'redux/datasource/dataSourceSlice';
import { useParams } from 'react-router-dom';
import { getUnitIds } from 'redux/auth/authSlice';

export const ExecutorLogs = panel => {
    const { id } = useParams();
    const { dispatch, select } = useCommonInits();
    const [pageSize, setPageSize] = useState(10);
    const logRequests = useSelector(getExecuteLogsByID);
    const unitsIDs = select(getUnitIds);
    const [stationName, setStationName] = useState('ALL');
    const Assets = select(getAssets);
    const [selectedRow, setSelectedRow] = useState(null);

    useEffect(() => {
        if (Assets) {
            const params = {
                filter: { EQUIP_TYPE: ['APCM'] },
                unit_id: unitsIDs,
            };
            dispatch(getAllAssets(params));
        }
    }, []);

    const getId = () => {
        return {
            price_request_id: id,
        };
    };

    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 2;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                // width: '22%',
            },
        },
    };
    useEffect(() => {
        const params = getId();
        dispatch(getLogsByID(params));
    }, []);

    const getFilteredData = () => {
        if (stationName === 'ALL') {
            return logRequests;
        } else {
            return logRequests.filter(data => data.asset_id === stationName);
        }
    };

    const getRetryRequest = selectedRows => {
        const requestData = {
            acknowledged: selectedRows?.acknowledged,
            asset_id: selectedRows?.asset_id,
            executed_date_time: selectedRows?.executed_date_time,
            gas_change_rate: selectedRows?.gas_change_rate,
            group_id: selectedRows?.group_id,
            group_name: selectedRows?.group_name,
            new_price: selectedRows?.new_price,
            price_request_id: selectedRows?.price_request_id,
            price_request_name: selectedRows?.price_request_name,
            published: selectedRows?.published,
            time: selectedRows?.time,
        };
        dispatch(getRetryRequests({ requestData, getId: getId() }));
    };

    const getRequestCancel = data => {
        const cancelData = {
            _id: data,
            status: 'cancel',
        };
        dispatch(getCancelRequests({ cancelData, getId: getId() }));
    };

    const columns = useMemo(
        () => [
            {
                field: 'retry',
                headerName: 'Action',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    // if(params.row.status === 'failed'){
                    return (
                        <>
                            <Button
                                variant="outlined"
                                style={{
                                    backgroundColor: 'green',
                                    border: '0px',
                                }}
                                onClick={() => getRetryRequest(params.row)}
                                disabled={params.row.status !== 'failed'}
                            >
                                Retry
                            </Button>
                            <Button
                                variant="outlined"
                                style={{
                                    backgroundColor: 'red',
                                    border: '0px',
                                    marginLeft: '5px',
                                }}
                                onClick={() => getRequestCancel(params.row._id)}
                                disabled={params.row.status !== 'failed'}
                            >
                                Cancel
                            </Button>
                        </>
                    );
                    // }
                },
            },
            {
                field: 'status',
                headerName: 'Status',
                width: 80,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (params.row.status === 'success') {
                        return (
                            <Typography style={{ color: 'green' }}>
                                {params.row.status.toUpperCase()}
                            </Typography>
                        );
                    } else if (params.row.status === 'failed') {
                        return (
                            <Typography style={{ color: 'red' }}>
                                {params.row.status.toUpperCase()}
                            </Typography>
                        );
                    } else if (params.row.status === 'N') {
                        return (
                            <Typography style={{ color: 'yellow' }}>
                                {'PENDING'}
                            </Typography>
                        );
                    } else {
                        return (
                            <Typography style={{ color: 'orange' }}>
                                {params.row.status.toUpperCase()}
                            </Typography>
                        );
                    }
                },
            },
            {
                field: 'publish_count',
                headerName: 'No. of Requests',
                width: 140,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'time',
                headerName: 'Executed Time',
                width: 190,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'new_price',
                headerName: 'New Price',
                width: 90,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'asset_id',
                headerName: 'Station Name',
                width: 220,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'group_name',
                headerName: 'Group Name',
                width: 240,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },

            {
                field: 'price_request_name',
                headerName: 'Price Request Name',
                width: 210,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'published',
                headerName: 'Published',
                width: 90,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },

            {
                field: 'acknowledged',
                headerName: 'Acknowledged',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },

            {
                field: 'gasChangeRate',
                headerName: 'Station Events',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
        ],
        [],
    );

    return (
        <>
            <Paper sx={{ margin: 1 }}>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    sx={{ p: 3 }}
                >
                    <Grid item>
                        <RequestPageIcon fontSize="large" />
                    </Grid>
                    <Grid item sx={{ pl: 1 }}>
                        <Typography variant="h5">Executed Logs</Typography>
                    </Grid>
                </Grid>
                <div>
                    <label style={{ marginLeft: '20px', marginRight: '5px' }}>
                        Stations :
                    </label>
                    <FormControl>
                        <Select
                            size="small"
                            value={stationName}
                            onChange={e => setStationName(e.target.value)}
                            sx={{
                                width: 200,
                                marginRight: '10px',
                                marginBottom: '10px',
                            }}
                            MenuProps={MenuProps}
                        >
                            <MenuItem value={'ALL'}>ALL</MenuItem>

                            {logRequests.map(item => {
                                return (
                                    <MenuItem
                                        value={item.asset_id}
                                        key={`interval-${item.asset_id}`}
                                    >
                                        {item.asset_id}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </div>
            </Paper>
            <Box sx={{ height: '78%', width: '100%', padding: 1 }}>
                <Paper sx={{ height: '100%', width: '100%' }}>
                    <DataGrid
                        disableColumnMenu
                        rows={getFilteredData()}
                        columns={columns}
                        getRowId={row => row._id}
                        autoHeight={true}
                        rowsPerPageOptions={[10, 25, 50]}
                        pageSize={pageSize}
                        onPageSizeChange={newPage => setPageSize(newPage)}
                        getRowSpacing={params => ({
                            top: params.isFirstVisible ? 0 : -2,
                            bottom: params.isLastVisible ? 0 : -2,
                        })}
                        sx={{
                            [`&.${gridClasses.row}`]: {
                                bgcolor: theme =>
                                    isDarkMode(theme) ? grey[200] : grey[900],
                            },
                        }}
                    />
                </Paper>
            </Box>
        </>
    );
};
